import React from "react";
import { VISIBLE_STAGES } from "../constants/config";
import { SURFACE, BORDER, TEXT, ACCENT } from "../constants/colors";
import PriorityBadge from "./PriorityBadge";
import { formatCurrency } from "../utils/formatCurrency";

const PipelineView = ({ cards }) => {
  return (
    <div style={{ flex: 1, padding: "24px", overflowY: "auto" }}>
      <div style={{ fontSize: 13, color: TEXT.muted, marginBottom: 16 }}>
        Pipeline Flow View — tracks each SKU through the full journey
      </div>
      {cards.slice(0, 10).map((card) => {
        const stageIdx = VISIBLE_STAGES.findIndex((s) => s.id === card.stage);
        return (
          <div
            key={card.id}
            style={{
              marginBottom: 16,
              background: SURFACE.navBg,
              border: `1px solid ${BORDER.subtle}`,
              borderRadius: 8,
              padding: "12px 16px",
            }}
          >
            {/* Card header */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 10,
              }}
            >
              <div>
                <span
                  style={{
                    fontSize: 10,
                    color: TEXT.muted,
                    fontFamily: "Poppins",
                    marginRight: 8,
                  }}
                >
                  {card.id}
                </span>
                <span
                  style={{ fontSize: 13, fontWeight: 600, color: TEXT.primary }}
                >
                  {card.title}
                </span>
                <span
                  style={{ fontSize: 11, color: TEXT.muted, marginLeft: 8 }}
                >
                  {card.supplier}
                </span>
              </div>
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <PriorityBadge priority={card.priority} />
                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: ACCENT.green,
                    fontFamily: "Poppins",
                  }}
                >
                  {formatCurrency(card.value)}
                </span>
              </div>
            </div>

            {/* Stage progress */}
            <div style={{ display: "flex", alignItems: "center", gap: 0 }}>
              {VISIBLE_STAGES.map((s, i) => {
                const done = i < stageIdx;
                const active = i === stageIdx;
                return (
                  <div
                    key={s.id}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      flex: i < VISIBLE_STAGES.length - 1 ? "1 1 0" : "0 0 auto",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: active ? 14 : 10,
                          height: active ? 14 : 10,
                          borderRadius: "50%",
                          background: done
                            ? ACCENT.green
                            : active
                              ? s.color
                              : BORDER.subtle,
                          border: `2px solid ${done ? ACCENT.green : active ? s.color : BORDER.subtle}`,
                          boxShadow: active ? `0 0 8px ${s.color}80` : "none",
                          transition: "all 0.2s",
                          flexShrink: 0,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {done && (
                          <span style={{ fontSize: 7, color: "#fff" }}>✓</span>
                        )}
                      </div>
                      {active && (
                        <span
                          style={{
                            fontSize: 8,
                            color: s.color,
                            marginTop: 2,
                            fontFamily: "Poppins",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {s.short}
                        </span>
                      )}
                    </div>
                    {i < VISIBLE_STAGES.length - 1 && (
                      <div
                        style={{
                          flex: 1,
                          height: 2,
                          background: done ? ACCENT.green : BORDER.subtle,
                          margin: "0 2px",
                          marginBottom: active ? 14 : 0,
                        }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PipelineView;
